import React from 'react'

export default function ContactUs() {
  return (
    <div className="container">
      <div className="heading display-1 font-weight-bold">
        CHACHA PRINTS
      </div>
      <div className="font-weight-light">
        Naya bazar, near dwarikadhish
        temple, Mathura
        <br />
        Uttar Pradesh
      </div>
      <br />
      <div>
        <i class="fab fa-whatsapp"></i>
        &ensp;(+91) - 9760092428
      </div>

      <div>
        <i
          class="fa fa-mobile"
          aria-hidden="true"
        ></i>
        &ensp;(+91) - 7253005811
      </div>
    </div>
  )
}
